//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import { makeStyles } from "@material-ui/core/styles";

// custom pages
import Login from "assets/img/login.jpg";
import Signup from "assets/img/signup.jpg";

export const loginStyles = makeStyles((theme) => ({
    row: {
        background: `url(${Login})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        position: "relative",
        // overflow: "hidden",
        "@media (min-width: 600px)": {
            height: "100%",
        },
    },
    leftCol: {
        background: "linear-gradient(rgb(0 0 0 / 0%), rgb(0 0 0 / 62%))",
    },
    rightCol: {
        backdropFilter: "blur(50px)",
        background: "linear-gradient(rgb(0 0 0 / 12%), rgba(0, 0, 0, 0.62))",

        // only for IE 9 or IE 11 browsers.
        "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
            background: "#999999",
        }
    },
    imgDiv: {
        margin: "100px 25px",
        "@media (max-width: 600px)": {
            margin: 0,
            textAlign: "center",
        },
    },
    img: {
        height: 200,
    },
    contentDiv: {
        margin: "0 60px",
        color: "#fff",
        fontSize: 45,
        fontFamily: "segoe-ui",
        "@media (max-width: 600px)": {
            margin: "0 10px",
            textAlign: "center",
        },
    },
    descriptionDiv: {
        color: "#fff",
        fontSize: 20,
        fontFamily: "segoe-ui",
    },
    iconDiv: {
        margin: "20px 60px",
        color: "#fff",
        fontSize: 25,
        "@media (max-width: 600px)": {
            margin: 20,
            textAlign: "center",
        },
    },
    icon: {
        marginRight: 25,
    }
}));

export const signupStyles = makeStyles((theme) => ({
    row: {
        backgroundImage: `url(${Login})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        position: "relative",
        overflow: "hidden",
        "@media (min-width: 600px)": {
            height: "100%",
        },
    },
    colRight: {
        background: "linear-gradient(rgb(0 0 0 / 0%), rgb(0 0 0 / 62%))",
    },
    colLeft: {
        backdropFilter: "blur(50px)",
        background: "linear-gradient(rgb(0 0 0 / 12%), rgba(0, 0, 0, 0.62))",
        // only for IE 9 or IE 11 browsers.
        "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
            background: "#999999",
            opacity: "0.9"
        }
    },
    descriptionDiv: {
        color: "#FFFFFF",
        fontSize: 20,
        fontFamily: "segoe-ui",
    },
    imgDiv: {
        margin: "100px 25px",
        "@media (max-width: 600px)": {
            margin: 0,
            textAlign: "center",
        },
    },
    img: {
        height: 200,
    },
    contentDiv: {
        margin: "0 60px",
        "@media (max-width: 600px)": {
            margin: "0 10px",
            textAlign: "center",
        },
    },
    contentHeadDiv: {
        color: "#FFFFFF",
        fontSize: 45,
        fontFamily: "segoe-ui",
        "@media (max-width: 600px)": {
            fontSize: 30,
        },
    },
    iconDiv: {
        margin: "40px 60px",
        "@media (max-width: 600px)": {
            margin: 20,
            textAlign: "center",
        },
    },
    icon: {
        marginRight: 25,
        color: "#fff",
        fontSize: 25,
    },
}));